import { Controller } from "@hotwired/stimulus"
import {
  effectiveThreshold as resolveThreshold,
  effectiveDelay as resolveDelay,
  thresholdDescription as describeThreshold,
  delayDescription as describeDelay,
} from "../lib/capacity_notifier"
import { reactor } from "../lib/reactor"

const SCHEDULE_SUFFIX = " during this schedule"

export default class extends Controller {
  static values = {
    mode: String,
    threshold: String,
    delay: String,
    thresholdPlaceholder: Number,
    delayPlaceholder: Number,
  }

  connect() {
    reactor(this)
  }

  isOverride() {
    return this.modeValue === "override"
  }

  effectiveThreshold() {
    return resolveThreshold(this.thresholdValue, this.thresholdPlaceholderValue)
  }

  effectiveDelay() {
    return resolveDelay(this.delayValue, this.delayPlaceholderValue)
  }

  thresholdDescription() {
    return describeThreshold(this.effectiveThreshold(), SCHEDULE_SUFFIX)
  }

  delayDescription() {
    return describeDelay(this.effectiveDelay(), SCHEDULE_SUFFIX)
  }
}
